module.exports = "https://cdn-shared.mathletics.com/mathsaz/99/assets/images/1de9151e20025c25cd4a2991297314c2.svg";